
// ROLES
export const GET_ROLES = "/roles";
export const ADD_NEW_ROLE = "/roles";
export const UPDATE_ROLE = "/roles";
export const DELETE_ROLE = "/roles";


